import { FC } from 'react';
import Breadcrumb, { BreadcrumbProps } from '../../components/molecules/Breadcrumb';
import useBreadcrumb from './useBreadcrumb';
const BreadcrumbWrapper: FC<{
  entries?: BreadcrumbProps['entries'];
}> = ({
  entries
}) => {
  const breadcrumbProps = useBreadcrumb(entries, [entries]);
  if (!entries?.length) return null;
  return <Breadcrumb {...breadcrumbProps} />;
};
export default BreadcrumbWrapper;